import styled, { css, keyframes } from 'styled-components'
import { colors, device, fonts } from '../../../styles/GlobalVariables'
import Link from '../../../components/Link/Link'

const loader = keyframes`
    0% {
        background-color: black;
    }
    100% {
        background-color: ${colors.tvGuideDark};
    }
`

export const EpisodeListItemLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`
export const EpisodeListItemWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  padding: 12px 0;

  ${device.medium} {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    padding: 25px 6vw;
  }

  ${device.small} {
    gap: 1rem;

    &:hover {
      background-color: #ffffff0d;
      width: 96.5%;
    }
  }

  @media only screen and (max-width: 768px) {
    gap: 12px;
    padding: 0;
  }
`
export const EpisodeListItemThumbnail = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 7px;
  transition: all 0.25s ease-in;
  transform-origin: center;
  display: inline-flex;
  height: unset;
  aspect-ratio: 16/9;
  max-width: 45%;
  min-width: 45%;
  max-height: 180px;

  img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${props =>
      !props.theme.bigImage &&
      css`
        max-width: 240px;
      `}
  }

  ${device.medium} {
    max-width: 100%;
    min-width: 240px;
    border-radius: 10px;
    position: relative;
    margin-right: unset;
    overflow: unset;

    img {
      border-radius: 10px;
      position: unset;
      top: unset;
      left: unset;
      transform: unset;
    }

    &:after {
      content: '';
      transition: opacity 0.25s ease-in;
      opacity: 0;
      position: absolute;
      bottom: 0.625rem;
      right: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg fill='white' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2rem' height='2rem' viewBox='0 0 163.861 163.861' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z'/%3E%3C/g%3E%3C/svg%3E");
      z-index: 1;
    }

    &:hover {
      transform: scale(1.05);

      &:after {
        opacity: 1;
      }
    }
  }

  ${props =>
    props.theme.useDefault
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
          }
        `
      : ''}

  ${props =>
    props.theme.loaded
      ? ''
      : css`
          animation: ${loader} 1s linear infinite;
        `}
    ${props =>
    props.theme.error
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
          }
        `
      : ''};
`
export const EpisodeListItemNowPlaying = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.44px;
  display: flex;
  background-color: rgba(0, 0, 0, 0.75);
  align-items: center;
  justify-content: center;
`
export const EpisodeListItemDetailsWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  color: white;
  justify-content: ${props => (props.itemProp ? '' : 'flex-start')};

  ${device.small} {
    gap: 6px;
  }

  ${device.medium} {
    gap: 0;
  }
`
export const EpisodeListItemTitle = styled.h3`
  margin-block-start: 0;
  margin-block-end: 0;
  color: #fff;
  font-family: ${fonts.default};
  font-size: 18px;
  font-weight: 300;
  letter-spacing: -0.54px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  font-style: normal;
  height: 36px;
  text-align: right;

  ${device.small} {
    height: auto;
    font-size: 22px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.44px;
  }
`
export const EpisodeListItemDescription = styled.p`
  max-width: 100%;
  display: none;

  ${device.medium} {
    color: rgba(255, 255, 255, 0.7);
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 5rem;
    letter-spacing: -0.4px;
    max-width: 945px;
    width: 945px;
    margin-top: 4px;
    hyphens: auto;
    word-break: break-word;
    overflow-wrap: break-word;
  }
`
export const EpisodeListItemDate = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  font-weight: 100;
  letter-spacing: -0.48px;
  height: 24px;
  position: relative;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
    margin-top: 0.375rem;
  }
`
